import { Injectable } from '@angular/core'
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpResponse,
} from '@angular/common/http'
import { catchError, Observable, tap, throwError } from 'rxjs'
import { Store } from '@ngxs/store'
import { AppActions } from './store/app.actions'

// prettier-ignore
interface EmbraceHttpException {
	title: string;
	status: number;
	detail: string;
	errors: {
		[key: string]: any;
	};
}

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
	#calls: string[] = []
	constructor(private readonly store: Store) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const { url } = request
		return next.handle(request).pipe(
			tap((ev) => {
				if (
					url.toLowerCase().includes('embracepetinsurance.com/api') ||
					url.toLowerCase().includes('azurewebsites.net/api')
				) {
					if (!(ev instanceof HttpResponse)) {
						this.#calls.push(request.url)
						this.store.dispatch(new AppActions.SetLoading(!!this.#calls.length))
						this.store.dispatch(new AppActions.AddLoadingUrl(url))

						return
					}
					this.#calls.pop()
					this.store.dispatch(new AppActions.SetLoading(!!this.#calls.length))
					this.store.dispatch(new AppActions.RemoveLoadingUrl(url))
				}
			}),
			catchError((err) => {
				console.error(err)
				const errorMessage = err.error
					? Object.keys(err.error).includes('traceId')
						? err.message
						: this.#parsedErrorMessage(err.error)
					: err
				this.#calls.length = 0
				this.store.dispatch([
					new AppActions.SetLoading(!!this.#calls.length),
					new AppActions.SetError(errorMessage),
					new AppActions.RemoveLoadingUrl(url),
				])

				return throwError(() => err)
			})
		)
	}

	#parsedErrorMessage(err: EmbraceHttpException | string): string {
		let error = typeof err === 'string' ? (JSON.parse(err) as EmbraceHttpException) : err
		return (
			error.detail?.split(' :: ')?.[1] ?? ((<any>error).message || 'An Unknown error occurred!')
		)
	}
}
